/* 甄姬（洛神） */
import { defineHero, U } from '../define.ts';

export default defineHero({
  id: 'zhenji', name: '甄姬', sub: '洛神', faction: 'wei', role: '刺客', weapon: 'sword',
  look: { knife: true, dual: true, weaponName: '雙刺', ranged: false, female: true, head: 'bun', robe: true, size: 0.96, fx: '#bfe8ff', c: { cloth: '#4a74c4', sleeve: '#4a74c4', armor: '#e8f2ff', flower: '#bfe8ff', fan: '#dfeeff' } },
  skills: [
    ['毒鏢', 'bolt', '毒鏢造成 {60/80/100/120} 傷害，目標中毒 15 秒（每秒 7/10/13/17 傷害），並緩速 40% 5 秒。', { x: { k: 'nuke', dmg: [60, 80, 100, 120], dot: { dps: [7, 10, 13, 17], dur: 15 }, debuff: { ms: 40, dur: 5 } }, aim: U(480), mp: [65, 100, 135, 170] }],
    ['朦朧之舞', 'passive', '{7/14/21/28}% 機率閃避普攻。', { pv: { evade: [7, 14, 21, 28] } }],
    ['閃擊', 'blink', '瞬移到敵人身邊並立刻攻擊一次，暈眩 0.5 秒。冷卻 {18/14/10/6} 秒（依本作節奏縮短）。', { x: { k: 'blinkhit', stun: 0.5 }, aim: U(480), wardHop: true, cd: [18, 14, 10, 6] }], // v0.3.3：W、E 對調，閃擊加暈眩
    ['背刺', 'passive', '普攻有 25% 機率造成 {2.5/2.75/3} 倍傷害。', { pv: { crit: { chance: 25, mult: [2.5, 2.75, 3] } } }], // v0.4.2：前期加強、後期削弱（舊版 10/15/20% 機率 4 倍）
  ],
});
